import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import docSheet from "../../../assets/Images/TempleDetail/doc-sheet.png";
import arrowUpRight from "../../../assets/Images/TempleDetail/mobile/arrow-up-right.svg";
import circleCheck from "../../../assets/Images/TempleDetail/mobile/circle-check.svg";
import { T, FONT } from "../shared";
import DocumentModal from "../DocumentModal";
import { MobileCard, MobileHeading } from "./shared";

// Figma "Mobile revamp" 739:17491 — Verified documents: one row per document (page preview on the
// left, title and "View document" on the right) and the verification note.

const isImage = (url) => /\.(png|jpe?g|webp|gif|avif)(\?|$)/i.test(String(url || ""));

const MobileDocuments = ({ documents = [] }) => {
  const [openDoc, setOpenDoc] = useState(null);
  const docs = documents.filter((d) => d?.url);
  if (!docs.length) return null;

  return (
    <MobileCard id="documents" sx={{ gap: "20px" }}>
      <MobileHeading eyebrow="Documents" hindi="॥ प्रमाण ॥" title="Verified documents" />
      <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {docs.map((doc, i) => (
          <Box
            key={doc.id ?? i}
            component="button"
            type="button"
            onClick={() => setOpenDoc({ ...doc, displayTitle: doc.title || doc.name || `Verified document ${i + 1}` })}
            sx={{
              display: "flex",
              gap: "14px",
              alignItems: "center",
              border: "1px solid #EFE4D3",
              borderRadius: "14px",
              overflow: "hidden",
              textDecoration: "none",
              p: 0, width: "100%", textAlign: "left", cursor: "pointer", font: "inherit",
              background: "#FFFFFF",
              "&:focus-visible": { outline: `2px solid ${T.gold}`, outlineOffset: "2px" },
            }}
          >
            <Box sx={{ width: "90px", height: "114px", flexShrink: 0, background: T.cream, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Box component="img" src={isImage(doc.url) ? doc.url : docSheet} alt="" loading="lazy" sx={{ width: "65px", height: "86px", borderRadius: "3px", objectFit: "cover" }} />
            </Box>
            <Box sx={{ flex: 1, minWidth: 0, pr: "10px", display: "flex", flexDirection: "column", gap: "8px" }}>
              <Typography sx={{ fontFamily: FONT, fontWeight: 700, fontSize: "14px", lineHeight: 1.5, color: T.ink, wordBreak: "break-word" }}>
                {doc.title || doc.name || `Verified document ${i + 1}`}
              </Typography>
              <Box sx={{ display: "flex", gap: "4px", alignItems: "center" }}>
                <Typography sx={{ fontFamily: FONT, fontWeight: 700, fontSize: "12px", lineHeight: "normal", color: T.red }}>View document</Typography>
                <Box component="img" src={arrowUpRight} alt="" sx={{ width: "14px", height: "14px" }} />
              </Box>
            </Box>
          </Box>
        ))}
      </Box>
      <Box sx={{ display: "flex", gap: "7px", alignItems: "flex-start" }}>
        <Box component="img" src={circleCheck} alt="" sx={{ width: "16px", height: "16px", flexShrink: 0 }} />
        <Typography sx={{ fontFamily: FONT, fontSize: "11px", lineHeight: 1.5, color: T.muted }}>All documents reviewed by Truehope's verification team</Typography>
      </Box>
      <DocumentModal doc={openDoc} onClose={() => setOpenDoc(null)} />
    </MobileCard>
  );
};

export default MobileDocuments;
